(() => {
  function init() {
    document.querySelectorAll('[data-doggi-sticky]').forEach(bar => {
      if (bar.dataset.ready) return;
      bar.dataset.ready = 'true';
      const section = document.getElementById('MainProduct-' + bar.dataset.section);
      const form = bar.querySelector('form');
      const variants = JSON.parse(bar.querySelector('[data-doggi-variants]').textContent);
      const input = () => section?.querySelector('input[name="quantity"]');
      let quantity = Number(input()?.value) || 1;
      function update() {
        quantity = Math.max(1, Number(input()?.value) || quantity);
        bar.querySelector('[data-count]').textContent = String(quantity).padStart(2, '0');
        bar.querySelector('[data-total]').textContent = '₹' + (399 * quantity).toLocaleString('en-IN');
        form.querySelector('[data-sticky-quantity]').value = quantity;
        bar.querySelector('[data-minus]').disabled = quantity <= (Number(input()?.min) || 1);
        const variant = section?.querySelector('form input[name="id"]');
        if (variant) form.querySelector('[name="id"]').value = variant.value;
        const selected = variants.find(item => String(item.id) === form.querySelector('[name="id"]').value);
        const compare = Number(selected?.compare_at_price) || 0;
        bar.querySelector('[data-compare-stack]').hidden = compare <= 39900;
        bar.querySelector('[data-compare]').textContent = '₹' + (compare * quantity / 100).toLocaleString('en-IN');
        bar.querySelector('[data-discount]').textContent = (compare > 39900 ? Math.round((compare - 39900) * 100 / compare) : 0) + '% Off';
      }
      function change(direction) {
        const field = input();
        const step = Number(field?.step) || 1;
        quantity = Math.max(Number(field?.min) || 1, Math.min(Number(field?.max) || Infinity, quantity + direction * step));
        if (field) {
          field.value = quantity;
          field.dispatchEvent(new Event('change', { bubbles: true }));
        }
        update();
      }
      bar.querySelector('[data-plus]').addEventListener('click', () => change(1));
      bar.querySelector('[data-minus]').addEventListener('click', () => change(-1));
      section?.addEventListener('change', update);
      if (section) new MutationObserver(update).observe(section, { childList: true, subtree: true });
      form.addEventListener('click', update, true);
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
